import React from "react"
import { makeStyles } from "makeStyles"
// import Button from "../Buttons/Button"

import Icon from "@mdi/react"
import { mdiPlus, mdiMinus } from "@mdi/js"

const useStyles = makeStyles()(() => ({
	IncreaseDecrease: {
		cursor: "pointer",
		userSelect: "none",
		background: "none",
		width: "33.3%",
		height: "38px",
		color: "#505e5f",
		border: "none",
		outline: "none",
		paddingTop: 4,
		"&:hover": {
			background: "none",
		},
	},
	input: {
		width: "33.3%",
		height: "33px",
		textAlign: "center",
		outline: "none",
		boxShadow: "none",
		borderRadius: 0,
		border: "none",
		fontSize: 17,
		paddingTop: 4,
		color: "#505e5f",
	},
	btnGroup: {
		display: "flex",
		width: "100px",
		borderRadius: 20,
		border: "1px solid #505e5f",
		background: "white",
	},
	"@media only screen and (max-width: 580px)": {
		input: {
			height: "28px",
		},
		btnGroup: {
			width: "130px",
		},
	},
	lockingSystemIncreaseDecrease: {
		height: 27,
		padding: 0,
		margin: 0,
		background: "none",
		border: "1px solid transparent",
		textAlign: "center",
		color: "#505e5f",
		cursor: "pointer",
		"&:focus": {
			outline: "none",
		},
	},
	lockingSystemInput: {
		width: 20,
		height: 27,
		margin: 0,
		textAlign: "center",
		border: "1px solid white",
		color: "#505e5f",

		"&:focus": {
			outline: "none",
		},
	},
}))

const ChangeAmountButton = ({
	quantity,
	onChange,
	minQuantity = 0,
	maxQuantity = Infinity,
	step = 1,
	disabled = false,
	isLockingSystemPage = false,
}: Props) => {
	const { classes } = useStyles()
	const validateChange = (delta: number) => {
		const newQuantity = quantity + delta
		if (newQuantity >= minQuantity && newQuantity <= maxQuantity) onChange(newQuantity)
	}

	const onChangeAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newQuantity = Number(event.target.value)
		const delta = newQuantity - quantity
		validateChange(delta)
	}

	if (isLockingSystemPage)
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					margin: "auto",
				}}
			>
				<button
					disabled={disabled}
					onClick={() => validateChange(-1)}
					className={classes.lockingSystemIncreaseDecrease}
				>
					<Icon path={mdiMinus} size={0.7} />
				</button>
				<input
					type="number"
					aria-label="Product Quantity"
					value={quantity}
					onChange={onChangeAmount}
					step={step}
					data-hj-whitelist
					disabled={disabled}
					className={classes.lockingSystemInput}
				/>

				<button
					disabled={disabled}
					onClick={() => validateChange(+1)}
					className={classes.lockingSystemIncreaseDecrease}
				>
					<Icon path={mdiPlus} size={0.7} />
				</button>
			</div>
		)

	return (
		<div className={classes.btnGroup}>
			<button
				disabled={disabled}
				onClick={() => validateChange(-1)}
				className={classes.IncreaseDecrease}
			>
				<Icon path={mdiMinus} size={0.8} />
			</button>
			<input
				type="number"
				aria-label="Product Quantity"
				value={quantity}
				step={step}
				onChange={onChangeAmount}
				data-hj-whitelist
				disabled={disabled}
				className={classes.input}
			/>

			<button
				disabled={disabled}
				onClick={() => validateChange(+1)}
				className={classes.IncreaseDecrease}
			>
				<Icon path={mdiPlus} size={0.8} />
			</button>
		</div>
	)
}

interface Props {
	quantity: number
	onChange: (newAmount: number) => void
	disabled?: boolean
	minQuantity?: number
	maxQuantity?: number
	step?: number
	isLockingSystemPage?: boolean
}

export default ChangeAmountButton
